module.exports = __webpack_public_path__ + "static/media/Reason.8e44d165.svg";